import { useCallback, useState } from 'react';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';

import { useLazyDownloadVpnConfigQuery } from 'src/features/room/room.slice';
import { preventReloadOrLeavePage } from 'src/features/certifications/exam/components/modals/modals.helpers';

import { useTrackDownloadOVPNMutation } from '../slices/analytics/download-ovpn';

export const useDownloadVpnConfig = (networkId?: string) => {
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  const [download] = useLazyDownloadVpnConfigQuery();
  const [trackDownloadOVPN] = useTrackDownloadOVPNMutation();

  const handleDownloadVpnConfig = useCallback(async () => {
    try {
      // Temporarily remove beforeunload, hacky temp. fix, should probably just remove all instances of beforeunload in the exam
      // Just need confirmation from the team or PM that this is not needed
      window.removeEventListener('beforeunload', preventReloadOrLeavePage, true);
      setIsDownloadLoading(true);
      const result = await download(networkId, false);
      await trackDownloadOVPN('access_machines_modal');
      if (!result.data?.data?.url) {
        throw new Error('Error downloading VPN config');
      }
      window.location.href = result.data.data.url;
    } catch {
      NotificationDispatch('error', 'Error downloading VPN config');
    } finally {
      setIsDownloadLoading(false);
      window.addEventListener('beforeunload', preventReloadOrLeavePage, true);
    }
  }, [download, networkId, setIsDownloadLoading, trackDownloadOVPN]);

  return {
    handleDownloadVpnConfig,
    isDownloadLoading,
  };
};
